module.exports = __webpack_public_path__ + "img/GUF.4ae07597.svg";